export default "__VITE_ASSET__CH7Il9GN__"